import React from 'react';
import PropTypes from 'prop-types';
import ActivityLink from '../../../activities/ActivityLink';
import './BulkActivitiesLink.scss';

const BulkActivitiesLink = ({ partialPdfName, name, className, onClick }) => {
    const s3ProxyPath =
        '/storage/litco-prod-uw2-d8-activities-production/activity_pdf%2Fbulk%2F';
    const kebabedName = name.replace(/[^\w]+/g, '-');
    const formattedPdfName = `${partialPdfName}-${kebabedName}-bulk.pdf`.toLowerCase();

    return (
        <span className={className}>
            <ActivityLink
                url={`${s3ProxyPath}${formattedPdfName}`}
                content={
                    <>
                        <i className="icon-v2-download" />
                        <span className="bulk-activities-text">&nbsp;Download all activities</span>
                    </>
                }
                onClick={onClick}
            />
        </span>
    );
};

BulkActivitiesLink.defaultProps = {
    partialPdfName: '',
    name: '',
    className: 'bulk-activities-link',
    onClick: () => {},
};

BulkActivitiesLink.propTypes = {
    partialPdfName: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default BulkActivitiesLink;
